import { useContext } from "react";

import { type EditModeValue, editModeContext } from "./edit-mode-context";

export function useEditMode(): EditModeValue {
  const ctx = useContext(editModeContext);

  if (!ctx) {
    throw new Error("useEditMode() called outside <EditModeProvider>");
  }

  return ctx;
}
